"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
type DropId = string | null | undefined;
type UseClosingDropIdResult = {
  readonly effectiveDropId: string | undefined;
  readonly beginClosingDrop: (dropId: string) => void;
};
export function useClosingDropId(dropId) {
  const $ = _c(7);
  const currentDropId = dropId ?? undefined;
  const [closingDropId, setClosingDropId] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = dropIdToClose => {
      setClosingDropId(dropIdToClose);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const beginClosingDrop = t0;
  let t1;
  let t2;
  if ($[1] !== closingDropId || $[2] !== currentDropId) {
    t1 = () => {
      if (closingDropId !== undefined && currentDropId !== closingDropId) {
        setClosingDropId(undefined);
      }
    };
    t2 = [currentDropId, closingDropId];
    $[1] = closingDropId;
    $[2] = currentDropId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = closingDropId !== undefined && currentDropId === closingDropId ? undefined : currentDropId;
  let t4;
  if ($[5] !== t3) {
    t4 = {
      effectiveDropId: t3,
      beginClosingDrop
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}